export default __webpack_public_path__ + "static/media/barcode-scan-icon.d0261083.svg";